import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type IPartnerNode = { id: number; name: string };

type partnerState = {
  list: IPartnerNode[] | [];
};

const initialState: partnerState = { list: [] };

const slice = createSlice({
  name: "partners",
  initialState,
  reducers: {
    setPartnersList(state, action: PayloadAction<partnerState>) {
      state.list = action.payload.list ?? [];
    },
    clearPartners(state) {
      state.list = [];
    },
  },
});

export const { setPartnersList, clearPartners } = slice.actions;
export default slice.reducer;
